/** Flags the new app reads from `/me`. */

/** @param {Record<string, unknown>|null|undefined} me */
export function readMemoryV2(me) {
  return !!(me && me.memory_v2);
}

/**
 * Chat block renderer (plan 2 §3a). Same `/auth/me` boolean as the other v2 flags.
 * @param {Record<string, unknown>|null|undefined} me
 */
export function readChatBlocksV2(me) {
  return !!(me && me.chat_blocks_v2);
}

/**
 * Product dashboard v2 (plan 2 S45). Same `/auth/me` boolean pattern.
 * @param {Record<string, unknown>|null|undefined} me
 */
export function readDashboardV2(me) {
  return !!(me && me.dashboard_v2);
}

/**
 * Deep analysis (plan 2). Same `/auth/me` boolean pattern; off unless the tenant has it.
 * @param {Record<string, unknown>|null|undefined} me
 */
export function readAnalysisEnabled(me) {
  return !!(me && me.analysis_enabled);
}
